// One flag: "a screen has unsaved work" (today only the workflow canvas). The top bar reads it to ask before
// "Switch user". It lives here and not in the kit's canvas store so the top bar never loads the heavy canvas code.
import { create } from 'zustand'

interface UnsavedWork {
  unsaved: boolean
  setUnsaved: (unsaved: boolean) => void
}

export const useUnsavedWork = create<UnsavedWork>((set) => ({
  unsaved: false,
  setUnsaved: (unsaved) => set({ unsaved }),
}))
